import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axioPath from '../../../../../api/axioPath';
import debounce from "lodash.debounce";
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper, ChartSection, ChartBox, SelectWrapper } from './dashBoardStyled';
import UserRequest from './Table'
import { addminNewUserList } from '../../../../../redux/actions/admin';
import LineChart from '../DashBoard/Charts/LineChart'
import BarChart from './Charts/BarChart'
import FilterIcon from '../../../../assets/images/filterIcon.png'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import Spinner from '../../../../components/Spinner'
import { setDashboardTableDetails, setDashboardOrderGraphDetails, setDashboardSubscriptionGraphDetails } from '../../../../../redux/actions/admin';

import { getAllStatesOfCountry, getAllCitiesOfState } from "helpers";

function DashBoard() {
    const dispatch = useDispatch();
    let history = useHistory()
    const [pageLoader, setPageLoader] = useState(false)
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [data, setData] = useState([]);
    const thisYear = (new Date()).getFullYear();
    const thisMonth = (new Date()).getMonth();
    let currentDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - currentDate.getDate() + 1);
    const monthOptions = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    const [userSubOptions, setuserSubOptions] = useState([]);
    const [lineChartData, setLineChartData] = useState([]);
    const [pieChartData, setPieChartData] = useState(null);
    const [modal, setModal] = useState(false);
    const [modalMessage, setModalMessaage] = useState('')
    const [orderPopModal, setOrderPopModal] = useState(false);
    const [userSubPopModal, setUserSubPopModal] = useState(false);
    const [month, setMonth] = useState(monthOptions[thisMonth])
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(1);
    const [totalNumberElement, settotalNumberElement] = useState(10);
    const [pageCount, setpageCount] = useState(0);
    const [orderGraphState, setOrderGraphState] = useState({
        state: '',
        city: '',
        userType: 'both',
        month: monthOptions[thisMonth],
        year: thisYear
    })
    const [lineGraphState, setlineGraphState] = useState({
        state: '',
        city: '',
        userType: 'all',
        month: monthOptions[thisMonth],
        year: thisYear
    })

    const handleOrderStateChange = (e) => {
        const { id, value } = e.target
        setOrderGraphState(prevState => ({
            ...prevState,
            [id]: value
        }))
        if (id === 'state' && value === '') {
            setOrderGraphState(prevState => ({
                ...prevState,
                city: value
            }))
        }
    }
    const handleSubscriptionStateChange = (e) => {
        const { id, value } = e.target
        setlineGraphState(prevState => ({
            ...prevState,
            [id]: value
        }))
        if (id === 'state' && value === '') {
            setOrderGraphState(prevState => ({
                ...prevState,
                city: value
            }))
        }
    }

    const states = getAllStatesOfCountry('US').map((state) => ({
        value: state.name,
        label: `${state.isoCode}-${state.name}`,
        isoCode: state.isoCode
    }));
    const currentOrderState = states
        .find((c) => c.value === orderGraphState.state)?.isoCode || '';
    const currentSubscriptionState = states
        .find((c) => c.value === lineGraphState.state)?.isoCode || '';

    const orderCities = getAllCitiesOfState(currentOrderState, 'US')
        ?.map((city) => ({ value: city, label: city })) ?? [];
    const SubscriptionCities = getAllCitiesOfState(currentSubscriptionState, 'US')
        ?.map((city) => ({ value: city, label: city })) ?? [];


    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller', 'Reseller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        fetchMyAPI()
        let tempUserSubOptions = []
        for (let year = thisYear; year >= thisYear - 10; year--) {
            tempUserSubOptions.push(year);
        }
        setuserSubOptions(tempUserSubOptions)
    }, []);


    const fetchMyAPI = async (type) => {
        let response = '';
        setPageLoader(true)
        response = await dispatch(addminNewUserList(page, tableSearch));
        if (response.statusCode === 401) {
            localStorage.removeItem('token')
            history.push('/sign-in')
            window.location.reload(false);
        }
        let adminUserDataList = response.data.content
        //   setpageCount(response.data.totalPages - 1)
        setpageCount(response.data.totalPages)
        settotalNumberElement(response.data.totalElements)
        setData(adminUserDataList)
        dispatch(setDashboardTableDetails(adminUserDataList))
        if (type !== 'refreshOnlyTable') fetchOrderApi()
        else setPageLoader(false);

        // if (response.status === 200 && response.data.success !== false) {
        //     if (response.length !== 0) {
        //         let adminUserDataList = response.data
        //         setData(adminUserDataList)
        //         dispatch(setDashboardTableDetails(adminUserDataList))
        //         if (type !== 'refreshOnlyTable') fetchOrderApi()
        //         else setPageLoader(false);
        //     }
        // } else {
        //     if (response.data && response.data.message === "Unauthorized (Invalid token)") {
        //         history.push('/sign-in')
        //     } else {
        //         setModalMessaage(response.data && response.data.message ? response.data.message : response.message)
        //         setModal(!modal)
        //     }
        //     setPageLoader(false)
        // }
    };

    const fetchOrderApi = () => {
        let url = ''
        const token = localStorage.getItem("token")
        setOrderPopModal(false)
        setMonth(orderGraphState.month)
        let monthValue = monthOptions.indexOf(orderGraphState.month) + 1
        if (monthValue < 10) monthValue = ("0" + monthValue)
        url = `order/admin/status?month=${monthValue}&year=${orderGraphState.year}&userType=${orderGraphState.userType}&city=${orderGraphState.city}&state=${orderGraphState.state}`
        axioPath.get(url, {
            headers: {
                Authorization: token,
                companyName: ''
            },
        }).then((response) => {
            if (response.data) {
                if (response.data.payload.length !== 0) {
                    // setPieChartData(response.data.payload.orders)
                    setPieChartData(response.data.payload)
                    dispatch(setDashboardOrderGraphDetails(response.data.payload.orders))
                }
            }
            fetchUserGraphApi();
        }).catch((ex) => {
            setPageLoader(false)
        });
    };

    const fetchUserGraphApi = () => {
        setUserSubPopModal(false)
        const token = localStorage.getItem("token")
        let monthValue = monthOptions.indexOf(lineGraphState.month) + 1
        if (monthValue < 10) monthValue = ("0" + monthValue)
        axioPath.get('/user/subscription/info', {
            headers: {
                Authorization: token,
                month: monthValue,
                year: lineGraphState.year,
                userType: lineGraphState.userType,
                city: lineGraphState.city,
                state: lineGraphState.state
            },
        }).then((response) => {
            if (response.data) {
                if (response.data.payload.length !== 0) {
                    let userSubList = response.data.payload
                    let tempData1 = Object.values(userSubList)
                    setLineChartData(tempData1)
                    dispatch(setDashboardSubscriptionGraphDetails(tempData1))
                }
            }
            setPageLoader(false)
        }).catch((ex) => {
            setPageLoader(false)
        });
    };

    const forceRefresh = e => {
        fetchMyAPI('refreshOnlyTable');
    }

    const handleToggle = () => {
        setModal(!modal);
    }

    const fetchAPIPagination = async (pageNumber, tableSearch) => {
        let response = '';
        setPageLoader(true)
        response = await dispatch(addminNewUserList(pageNumber, tableSearch));
        if (response.statusCode === 401) {
            localStorage.removeItem('token')
            history.push('/sign-in')
            window.location.reload(false);
        }
        let adminUserDataList = response.data.content
        setpageCount(response.data.totalPages)
        setData(adminUserDataList)
        setPageLoader(false);
    }

    const handlePagination = async (pageNumber, tableSearch) => {
        setPage(pageNumber)
        fetchAPIPagination(pageNumber, tableSearch)
    }

    const handleSearchPagination = async (pageNumber, tableSearch) => {
        let search = tableSearch
        setTableSearch(search)
        setPage(1)
        handleDebounceSearch(search);

    }

    const handleDebounceSearch = useCallback(debounce((value) => fetchAPIPagination(1, value), 500), []);

    return (
        <div>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('DASHBOARD_ADMIN'))) ?
                <Wrapper>
                    {pageLoader && <Spinner />}
                    <ChartSection>

                        <TableWrapper>
                            <Heading>
                                <h3>Orders</h3>
                                <div style={{ display: 'flex', background: '#fff' }}>
                                    <img src={FilterIcon} alt="" onClick={() => setOrderPopModal(true)} />
                                </div>
                            </Heading>
                            <ChartBox>
                                <BarChart data={pieChartData} month={month} stateMonth={orderGraphState} />
                            </ChartBox>
                        </TableWrapper>

                        <TableWrapper>
                            <Heading>
                                <h3>User Subscription</h3>
                                <div style={{ display: 'flex', background: '#fff' }}>
                                    <img src={FilterIcon} alt="" onClick={() => setUserSubPopModal(true)} />
                                </div>
                            </Heading>
                            <ChartBox >
                                <LineChart data={lineChartData} />
                            </ChartBox>
                        </TableWrapper>

                    </ChartSection >
                    <UserRequest data={data} action={forceRefresh} handlePagination={handlePagination} handleSearchPagination={handleSearchPagination} pageCount={pageCount} currentPage={page} totalNumberElement={totalNumberElement} />
                </Wrapper >
                :
                <p>You are not authorized to view this page.</p>
            }

            <Modal isOpen={modal} centered={true} size='md'>
                <ModalBody>
                    {modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleToggle}>OK</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={orderPopModal} centered={true} size='md'>
                <ModalHeader toggle={() => setOrderPopModal(false)}>
                    <h6>Order Filters</h6>
                </ModalHeader>
                <ModalBody>
                    <div className="row px-2">
                        <div className="col-md-5 col-sm-6 col-6 px-2">
                            <SelectWrapper>
                                <label>Month</label>
                                <select className='chartModal' id='month' value={orderGraphState.month} onChange={handleOrderStateChange}>
                                    {
                                        monthOptions.map((data, index) => {
                                            return <option value={data}>{data}</option>
                                        })
                                    }
                                </select>
                            </SelectWrapper>
                        </div>

                        <div className="col-md-7 col-sm-6 px-2 col-6">
                            <SelectWrapper>
                                <label>Year</label>
                                <select className='chartModal' id='year' value={orderGraphState.year} onChange={handleOrderStateChange}>
                                    {
                                        userSubOptions.map((data, index) => {
                                            return <option value={data}>{data}</option>
                                        })
                                    }
                                </select>
                            </SelectWrapper>
                        </div>

                        <div className="col-md-5 col-sm-6 col-6 px-2">
                            <SelectWrapper>
                                <label>State</label>
                                <select className='chartModal' id='state' value={orderGraphState.state} onChange={handleOrderStateChange}>
                                    <option value=''>All</option>
                                    {
                                        states.map((data, index) => {
                                            return <option value={data.value}>{data.label}</option>
                                        })
                                    }
                                </select>
                            </SelectWrapper>
                        </div>


                        <div className="col-md-7 col-sm-6 col-6 px-2">
                            <SelectWrapper>
                                <label>City</label>
                                <select className='chartModal' id='city' value={orderGraphState.city} onChange={handleOrderStateChange}>
                                    <option value=''>All</option>
                                    {
                                        orderCities.map((data, index) => {
                                            return <option value={data.label}>{data.label}</option>
                                        })
                                    }
                                </select>
                            </SelectWrapper>
                        </div>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={fetchOrderApi}>Submit</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={userSubPopModal} centered={true}>
                <ModalHeader toggle={() => setUserSubPopModal(false)}>
                    <h6>User Subscription Filters</h6>
                </ModalHeader>
                <ModalBody>
                    <div className="row px-2">
                        <div className="col-md-5 col-sm-6 col-6 px-2">
                            <SelectWrapper>
                                <label>Month</label>
                                <select className='chartModal' id='month' value={lineGraphState.month} onChange={handleSubscriptionStateChange}>
                                    {
                                        monthOptions.map((data, index) => {
                                            return <option value={data}>{data}</option>
                                        })
                                    }
                                </select>
                            </SelectWrapper>
                        </div>
                        <div className="col-md-5 col-sm-6 col-6 px-2">
                            <SelectWrapper>
                                <label>Year</label>
                                <select className='chartModal' id='year' value={lineGraphState.year} onChange={handleSubscriptionStateChange}>
                                    {
                                        userSubOptions.map((data, index) => {
                                            return <option value={data}>{data}</option>
                                        })
                                    }
                                </select>
                            </SelectWrapper></div>
                        <div className="col-md-5 col-sm-6 col-6 px-2"> <SelectWrapper>
                            <label>State</label>

                            <select className='chartModal' value={lineGraphState.state} id='state' onChange={handleSubscriptionStateChange}>
                                <option value=''>All</option>
                                {
                                    states.map((data, index) => {
                                        return <option value={data.value}>{data.label}</option>
                                    })
                                }
                            </select>
                        </SelectWrapper></div>


                        <div className="col-md-7 col-sm-6 col-6 px-2"><SelectWrapper>
                            <label>City</label>

                            <select className='chartModal' value={lineGraphState.city} id='city' onChange={handleSubscriptionStateChange}>
                                <option value=''>All</option>
                                {
                                    SubscriptionCities.map((data, index) => {
                                        return <option value={data.label}>{data.label}</option>
                                    })
                                }
                            </select>
                        </SelectWrapper></div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={fetchUserGraphApi}>Submit</Button>
                </ModalFooter>
            </Modal>
        </div >
    )
};

export default DashBoard;
